// @flow
import React from 'react';
// Components
import { Helmet } from 'react-helmet';
import { PageTitleWithGoBack } from '../../common';
import FaqHit from '../components/FaqHit';
// Data
import faq from '../data/faq';
// Styles
import './FaqPage.css';

const FaqPage = () => {
  return (
    <div className="faq-page-main">
      <Helmet>
        <title>Perguntas Frequentes - Bigdelivery, Seu açougue virtual</title>
      </Helmet>

      <PageTitleWithGoBack title="Perguntas frequentes" />
      <div className="faq-page-hits">
        {faq.map((hit, ind) => (
          <FaqHit key={ind} question={hit.question} answer={hit.answer} />
        ))}
      </div>
    </div>
  );
};

export default FaqPage;
